import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNotifications } from "@toolpad/core";
import React, { useEffect, useState } from "react";
import { fetchSuperusers, toggleUserRole } from "../services/adminService";
import AddWebUser from "./AddWebUser";
import CustomTable from "./CustomTable";
import ConfirmationModal from "./modal/ConfirmationModal";
import ModalWindow from "./modal/ModalWindow";

export default function WebUsers(props) {
  const [superusers, setSuperusers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isWebUserModalVisible, setIsWebUserModalVisible] = useState(false);
  const notifications = useNotifications();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedCisloOdberatele, setSelectedCisloOdberatele] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchSuperusers();

      if (result?.data) {
        setSuperusers(result.data);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleSubmitConfirmed = async (cisloOdberatele) => {
    const result = await toggleUserRole(cisloOdberatele);

    if (result?.success) {
      setError("");
      setSuperusers(
        superusers.filter(
          (superuser) => superuser.cisloOdberatele !== cisloOdberatele
        )
      );
      setConfirmModalOpen(false);
      notifications.show("Web odběratel byl odstraněn.", {
        severity: "success",
        autoHideDuration: 5000,
      });
    }
  };
  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<PersonAddIcon />}
        onClick={() => setIsWebUserModalVisible(true)}
      >
        Přidat web odběratele
      </Button>
      {superusers?.length > 0 ? (
        <CustomTable
          columns={[
            ...props.customerColumns,
            {
              id: "akce",
              label: "Akce",
              renderCell: (value, row) => (
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setSelectedCisloOdberatele(row.cisloOdberatele);
                    setConfirmModalOpen(true);
                  }}
                >
                  Odebrat
                </Button>
              ),
            },
          ]}
          data={superusers}
          getRowKey={(row) => row.cisloOdberatele}
        />
      ) : (
        <Typography variant="h5" sx={{ mt: 1 }}>
          Nemáte žádne web odběratele
        </Typography>
      )}

      {isWebUserModalVisible && (
        <ModalWindow
          visible={isWebUserModalVisible}
          setVisible={setIsWebUserModalVisible}
        >
          <AddWebUser
            setSuperusers={setSuperusers}
            setModalVisible={setIsWebUserModalVisible}
          />
        </ModalWindow>
      )}
      {confirmModalOpen && (
        <ConfirmationModal
          visible={confirmModalOpen}
          setVisible={setConfirmModalOpen}
          title="Potvrzení"
          message="Opravdu chcete odebrat web odběratele?"
          onConfirm={() => handleSubmitConfirmed(selectedCisloOdberatele)}
        />
      )}
    </>
  );
}
